import "@hotwired/turbo-rails";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/css/v4-shims.min.css";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

await import("bootstrap/dist/js/bootstrap");

import moment from "./utils/moment_round";
window.moment = moment;

await import("./controllers");
